import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { motion } from 'framer-motion';
type Language = 'EN' | 'ES';
export function LanguageToggle() {
  const [language, setLanguage] = useState<Language>('EN');
  return <div className="relative flex items-center gap-1 bg-gray-100 rounded-lg p-1" data-id="element-226">
      <Globe className="w-4 h-4 text-gray-500 ml-1" data-id="element-227" />
      {(['EN', 'ES'] as Language[]).map(lang => <button key={lang} onClick={() => setLanguage(lang)} className="relative px-2.5 py-1 text-xs font-semibold rounded-md transition-colors z-10" data-id="element-228">
          {language === lang && <motion.div layoutId="language-indicator" className="absolute inset-0 bg-white rounded-md shadow-sm" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.4
      }} data-id="element-229" />}
          <span className={`relative z-10 ${language === lang ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-230">
            {lang}
          </span>
        </button>)}
    </div>;
}